"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckIsAffiliationDuplicatedResponse = exports.GetAffiliationsSummaryResponse = exports.UpdateAffiliationResponse = exports.GetAffiliationResponse = exports.DeleteAffiliationsResponse = exports.CreateAffiliationResponse = void 0;
class CreateAffiliationResponse {
}
exports.CreateAffiliationResponse = CreateAffiliationResponse;
class DeleteAffiliationsResponse {
}
exports.DeleteAffiliationsResponse = DeleteAffiliationsResponse;
class GetAffiliationResponse {
}
exports.GetAffiliationResponse = GetAffiliationResponse;
class UpdateAffiliationResponse {
}
exports.UpdateAffiliationResponse = UpdateAffiliationResponse;
class GetAffiliationsSummaryResponse {
}
exports.GetAffiliationsSummaryResponse = GetAffiliationsSummaryResponse;
class CheckIsAffiliationDuplicatedResponse {
}
exports.CheckIsAffiliationDuplicatedResponse = CheckIsAffiliationDuplicatedResponse;
//# sourceMappingURL=affiliation.js.map